/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DtoAccountInfoBaseResponse as ModelsAccountDtoAccountInfoBaseResponse } from '../models/Models/Account/dto-account-info-base-response';
import { v4AccountsEntityIdInfoGet$Json } from '../fn/accounts/v-4-accounts-entity-id-info-get-json';
import { V4AccountsEntityIdInfoGet$Json$Params } from '../fn/accounts/v-4-accounts-entity-id-info-get-json';
import { v4AccountsEntityIdInfoGet$Plain } from '../fn/accounts/v-4-accounts-entity-id-info-get-plain';
import { V4AccountsEntityIdInfoGet$Plain$Params } from '../fn/accounts/v-4-accounts-entity-id-info-get-plain';
import { v4AccountsEntityIdInfoGet$Xml } from '../fn/accounts/v-4-accounts-entity-id-info-get-xml';
import { V4AccountsEntityIdInfoGet$Xml$Params } from '../fn/accounts/v-4-accounts-entity-id-info-get-xml';

@Injectable({ providedIn: 'root' })
export class AccountsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4AccountsEntityIdInfoGet()` */
  static readonly V4AccountsEntityIdInfoGetPath = '/v4/accounts/{entityId}/info';

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AccountsEntityIdInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Plain$Response(params: V4AccountsEntityIdInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>> {
    return v4AccountsEntityIdInfoGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AccountsEntityIdInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Plain(params: V4AccountsEntityIdInfoGet$Plain$Params, context?: HttpContext): Observable<ModelsAccountDtoAccountInfoBaseResponse> {
    return this.v4AccountsEntityIdInfoGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>): ModelsAccountDtoAccountInfoBaseResponse => r.body)
    );
  }

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AccountsEntityIdInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Json$Response(params: V4AccountsEntityIdInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>> {
    return v4AccountsEntityIdInfoGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AccountsEntityIdInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Json(params: V4AccountsEntityIdInfoGet$Json$Params, context?: HttpContext): Observable<ModelsAccountDtoAccountInfoBaseResponse> {
    return this.v4AccountsEntityIdInfoGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>): ModelsAccountDtoAccountInfoBaseResponse => r.body)
    );
  }

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4AccountsEntityIdInfoGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Xml$Response(params: V4AccountsEntityIdInfoGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>> {
    return v4AccountsEntityIdInfoGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets account info.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4AccountsEntityIdInfoGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4AccountsEntityIdInfoGet$Xml(params: V4AccountsEntityIdInfoGet$Xml$Params, context?: HttpContext): Observable<ModelsAccountDtoAccountInfoBaseResponse> {
    return this.v4AccountsEntityIdInfoGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>): ModelsAccountDtoAccountInfoBaseResponse => r.body)
    );
  }

}
